import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SalesForceUpdatePage extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    collectionsBySalesforce: [],
    collectionsByexternaldb: [],
  };

  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    console.log('match.params', match.params);
    await actions.loadExternalDatabaseForSalesforce({ projectId, externalDbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid: externalDbUuid, version });
    const { externalDbSalesforce, collectionList } = this.props.dataConnector;
    console.log('componentDidMount', externalDbSalesforce);
    const { completeData } = externalDbSalesforce;
    this.setState({ collectionsBySalesforce: completeData.tables });
    this.setState({ collectionsByexternaldb: collectionList });
  }
  handleCreateCollection = (index) => {
    const { match, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/salesforce-datasource/${externalDbUuid}/create`,
      {
        collectionIndex: index,
      },
    );
  };
  handleUpdateCollection = (item) => {
    const { match, history } = this.props;
    const { projectId, externalDbUuid, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/salesforce-update/${externalDbUuid}/update/${item.name}`,
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { collectionsBySalesforce, collectionsByexternaldb } = this.state;
    const collectionsWithDb = collectionsByexternaldb.map((a) => a.collectionTitle);
    const { loadExternalDatabaseForDirectusPending, collectionListExternaldbsPending } =
      this.props.dataConnector;
    if (loadExternalDatabaseForDirectusPending || collectionListExternaldbsPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForDirectusPending || collectionListExternaldbsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      collectionsBySalesforce && (
        <CommonPageComponent>
          <ParentContentCard title={'All Collections in  Directus Database'} icon={'collection'}>
            <div className="grid__column">
              {collectionsBySalesforce.map((item, index) => (
                <span
                  className={`card card--user-profile ml-4 card--collection-source`}
                  key={index}
                >
                  <div className="card-body">
                    <div className="avatar__meta">
                      <h5 className="avatar__title js-user-name" title={item.name}>
                        {item.label}
                      </h5>
                      {collectionsWithDb.includes(item.label) ? (
                        <button
                          className="btn btn-theme-submit btn-md"
                          onClick={() => this.handleUpdateCollection(item)}
                        >
                          <i className="wb webconnect-save-regular"> </i>
                          {' Update'}
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary btn-md"
                          onClick={() => this.handleCreateCollection(index)}
                        >
                          <i className="wb webconnect-plus"> </i>
                          {' Create'}
                        </button>
                      )}
                    </div>
                  </div>
                </span>
              ))}
            </div>
          </ParentContentCard>
        </CommonPageComponent>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesForceUpdatePage);
